import { useEffect } from "react";
import { useFlag } from "../../../server/optimizely";
import { serviceURL } from "../../../utils/service-url";

import type { UUID } from "../../../utils/uuid";

export const segmentEngineSocketURL = (segmentId: UUID): URL => {
  const url = new URL(segmentId, serviceURL("segment-engine"));
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url;
};

/**
 * Opens a WebSocket to the segment-engine Durable Object for this segment
 */
export const useSegmentEngineSocket = (segmentId: UUID | null): void => {
  const [enabled] = useFlag("cha_4571_segment_engine_websocket");

  useEffect(() => {
    if (!enabled || !segmentId) return undefined;

    const socket = new WebSocket(segmentEngineSocketURL(segmentId));
    // The engine can't message first (Cloudflare has no onOpen), so ask it to answer.
    socket.addEventListener("open", () => socket.send("hello"));
    socket.addEventListener("message", (event) => console.log("segment-engine:", event.data));
    socket.addEventListener("error", (event) =>
      console.error("segment-engine socket error", event),
    );

    return () => socket.close();
  }, [enabled, segmentId]);
};
